import * as React from 'react';
import { translation, currencyFormatter, translate } from 'easit--localization';
import { CheckBox, InfoBox, CountDownLoader, SubmitMessageIcon } from 'common--design-library';
import { CashoutAcceptedChangeTypeUI, ProgressStateModel } from 'eTip--common';
import { RateCashoutOptions } from '../ticketAndCoupon/rateCashout';
import classNames from 'classnames';


export interface IBetDetailCashoutProps {
    cashOut: number;
    cashOutErrors: string[] | null;
    cashOutState: ProgressStateModel;
    cashoutAcceptedChangeType: CashoutAcceptedChangeTypeUI;
    decreaseAgreement: boolean;
    decreaseAgreementPercents: number[];
    decreaseValue: number;
    isCashoutAvailable: boolean;

    isMobile: boolean;
    showLabel?: boolean;
    isCountDownEnabled: boolean;
    numberToCountDown: number;

    onCashOut: () => void;
    onDecreaseAgreementChange: (value: boolean) => void;
    onCashoutAcceptedChangeType: (value: CashoutAcceptedChangeTypeUI) => void;
    onDecreaseValueChange: (value: number) => void;
}

export const BetDetailCashout: React.FC<IBetDetailCashoutProps> = (data: IBetDetailCashoutProps) => {
    let isErrorToShow = data.cashOutState == ProgressStateModel.Failed && data.cashOutErrors && data.cashOutErrors.length > 0;
    return data.cashOutState == ProgressStateModel.Success
        ? <div className={__IsMTSTipos__ ? "submit-message" : "alert cashout-success"}><SubmitMessageIcon className="fa fa-check accepted" /> {translation().bet_SuccessfulCashout}</div>
        :
        (
            <React.Fragment>
                {
                    (data.isCashoutAvailable || isErrorToShow) &&
                    <div className={`cashout-component  ${data.isMobile ? 'mobile' : 'desktop'}`}>
                        {
                            data.showLabel &&
                            <span className={`cashout-label${__IsMTSTipos__ && data.isMobile ? '-tipos' : ''}`}>{translation().bet_Cashout}</span>
                        }

                        {
                            data.isCashoutAvailable &&
                            <div className="cashout-wrapper">
                                {!__IsMTSTipos__ && (
                                    <>
                                        <span className="fa fa-info"></span>
                                        <span className="">
                                            {translate("bet_ReallyCashoutBetOfValue", { value: currencyFormatter.format(data.cashOut) }).bet_ReallyCashoutBetOfValue}
                                        </span>
                                        <br />
                                    </>
                                )}

                                <div className="cashout-decrease-wrapper">
                                    {__IsMTSTipos__ ? (
                                        <RateCashoutOptions
                                            selectedOption={data.cashoutAcceptedChangeType}
                                            selectOption={(selectedOption) => data.onCashoutAcceptedChangeType(selectedOption)}
                                            isEnabledUI={data.cashOutState != ProgressStateModel.Loading}
                                        />
                                    ) : (
                                        <>
                                            <CheckBox key={"change"}
                                                isChecked={data.decreaseAgreement}
                                                onChangehandler={() => { data.onDecreaseAgreementChange(!data.decreaseAgreement) }}
                                                isDisabled={data.cashOutState === ProgressStateModel.Loading}
                                            >
                                                <span className="decrease-agreement-text">{translation().bet_AgreeWithLowerAmount}</span>
                                            </CheckBox>
                                            {
                                                <select className="cashout-decrease-amount" value={data.decreaseValue}
                                                    onChange={(e) => { data.onDecreaseValueChange(Number(e.target.value)) }}
                                                    disabled={data.cashOutState === ProgressStateModel.Loading}
                                                >
                                                    {
                                                        data.decreaseAgreementPercents.map(item => <option value={item} key={item}>{item}%</option>)
                                                    }
                                                </select>
                                            }
                                        </>
                                    )}
                                    <div className={classNames("btn cashout-button align-items-center", __IsMTSTipos__ ? "btn-success" : "btn-primary")} data-test-role="cashout__submit"
                                        onClick={() => { data.cashOutState != ProgressStateModel.Loading && data.onCashOut(); }}
                                    >

                                        {__IsMTSTipos__ ? translate("coupon_cashoutButton", { value: currencyFormatter.format(data.cashOut) }).coupon_cashoutButton : translation().bet_Cashout}
                                        {data.cashOutState == ProgressStateModel.Loading && <>
                                            <span className="fas fa-spinner fa-spin ml-2"></span>
                                            {data.isCountDownEnabled &&
                                                <span className="ml-2"> <CountDownLoader cnt={data.numberToCountDown} /></span>
                                            }
                                        </>}
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            (isErrorToShow) &&
                            <InfoBox type='error' messages={data.cashOutErrors.map(error => { return { text: error, withIcon: true } })} />
                        }
                    </div>
                }
            </React.Fragment >
        )
}